"use client";
import { ToggleGroup, ToggleGroupItem } from "@layer/ui/components";
import { useLocale } from "next-intl";
import { useTransition } from "react";
import { type Locale, locales } from "@/lib/locale/config";
// import { i18n, Locale } from '@/lib/locale/i18n.config';
import { setUserLocale } from "@/lib/locale/services/locale";

// When we add more than one lang, we need to consider using cookies to detect locale.
const LangSelection = () => {
	const currentLocale = useLocale();
	const [, startTransition] = useTransition();

	const changeLocale = (value: string) => {
		const locale = value as Locale;

		console.info("Value", value);
		startTransition(() => {
			setUserLocale(locale);
		});
	};

	return (
		<ToggleGroup
			type="single"
			value={currentLocale}
			onValueChange={changeLocale}
			isSettings
			// onValueChange=missing...
		>
			{locales.map((locale: Locale) => (
				<ToggleGroupItem key={locale} value={locale} isSettings>
					{locale.toUpperCase()}
				</ToggleGroupItem>
			))}
		</ToggleGroup>
	);
};

export { LangSelection };
